/* Mach Outlet — barra flotante de compra: aparece cuando el botón principal
   de la ficha sale de la pantalla por arriba. Ausente por completo cuando el
   producto no admite compra (el Liquid no la renderiza en ese caso). */
(function () {
  function init() {
    var bars = document.querySelectorAll('[data-mo-floating-bar]');
    bars.forEach(function (bar) {
      if (bar.dataset.moReady === '1') return;
      var sectionId = bar.id.replace('MoFloatingBar-', '');
      var anchor = document.getElementById('mo-buy-anchor-' + sectionId);
      if (!anchor || typeof IntersectionObserver === 'undefined') return;
      bar.dataset.moReady = '1';

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var pastIt = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', pastIt);
          });
        },
        { threshold: 0 }
      );
      observer.observe(anchor);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
